export const API_PATH_ApiDeviceMgmtLocationsDevicesGet = '/services/devices-mgtm/apiDeviceMgmtLocationsDevicesGet';
